// #ea6095
//export const PRIMARY_COLOR= '#aa2d62'
//export const ON_PRIMARY_COLOR = '#ffffff'
//export const PRIMARY_CONTAINER_COLOR = '#ffd9e2'
//export const ON_PRIMARY_CONTAEINER_COLOR = '#3e001d'

export const PRIMARY_COLOR= '#000000'
export const ON_PRIMARY_COLOR = '#ffffff'
export const PRIMARY_CONTAINER_COLOR = '#0095f6'
export const ON_PRIMARY_CONTAEINER_COLOR = '#ffffff'

export const SECONDARY_COLOR= '#74565f'
export const ON_SECONDARY_COLOR = '#ffffff'
export const SECONDARY_CONTAINER_COLOR = '#262626'
export const ON_SECONDARY_CONTAEINER_COLOR = '#2b151c'

//export const SECONDARY_COLOR= '#74565f'
//export const ON_SECONDARY_COLOR = '#ffffff'
//export const SECONDARY_CONTAINER_COLOR = '#ffd9e2'
//export const ON_SECONDARY_CONTAEINER_COLOR = '#2b151c'

export const TERTIARY_COLOR= '#7c5635'
export const ON_TERTIARY_COLOR = '#ffffff'
export const TERTIARY_CONTAINER_COLOR = '#efefef'
export const ON_TERTIARY_CONTAEINER_COLOR = '#000000'

//export const TERTIARY_COLOR= '#7c5635'
//export const ON_TERTIARY_COLOR = '#ffffff'
//export const TERTIARY_CONTAINER_COLOR = '#ffdcc2'
//export const ON_TERTIARY_CONTAEINER_COLOR = '#2b1500'

export const ERROR_COLOR = '#ba1a1a'
export const ON_ERROR_COLOR = '#ffffff'
export const ERROR_CONTAINER_COLOR = '#ffdad6'
export const ON_ERROR_CONTANIER_COLOR = '#410002'

export const BREAK_POINT_PHONE_TAB = 481